/**
 * index.tsx — Entry point for the React PDF viewer
 *
 * Mounts <PaperViewer /> into #pdf-react-root, which lives inside
 * the existing Jinja-rendered page. Everything outside this div
 * (sidebar, panel resizer, chat) remains vanilla JS.
 */
import React from "react";
import { createRoot } from "react-dom/client";
import { PaperViewer } from "./PaperViewer";

function mount() {
  const el = document.getElementById("pdf-react-root");
  if (!el) {
    console.warn("[pdf-viewer] No #pdf-react-root found, skipping mount");
    return;
  }
  const root = createRoot(el);
  root.render(
    <React.StrictMode>
      <PaperViewer />
    </React.StrictMode>
  );
}

// Mount on DOMContentLoaded if document not ready, else mount immediately
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount);
} else {
  mount();
}
